import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Catal\xE0",
  code: "ca",
  messages: {
    alert: {
      close: "Tancar"
    },
    authForm: {
      hidePassword: "Amagar contrasenya",
      showPassword: "Mostrar contrasenya",
      submit: "Continuar"
    },
    banner: {
      close: "Tancar"
    },
    calendar: {
      nextMonth: "Mes seg\xFCent",
      nextYear: "Any seg\xFCent",
      prevMonth: "Mes anterior",
      prevYear: "Any anterior"
    },
    carousel: {
      dots: "Tria la diapositiva a mostrar",
      goto: "Anar a la diapositiva {slide}",
      next: "Seg\xFCent",
      prev: "Anterior"
    },
    chatPrompt: {
      placeholder: "Escriu el teu missatge aqu\xED..."
    },
    chatPromptSubmit: {
      label: "Enviar"
    },
    colorMode: {
      dark: "Fosc",
      light: "Clar",
      switchToDark: "Canviar a mode fosc",
      switchToLight: "Canviar a mode clar",
      system: "Sistema"
    },
    commandPalette: {
      back: "Enrere",
      close: "Tancar",
      noData: "Sense dades",
      noMatch: "No hi ha dades coincidents",
      placeholder: "Escriu una ordre o cerca..."
    },
    contentSearch: {
      links: "Enlla\xE7os",
      theme: "Tema"
    },
    contentSearchButton: {
      label: "Cercar..."
    },
    contentToc: {
      title: "En aquesta p\xE0gina"
    },
    dashboardSearch: {
      theme: "Tema"
    },
    dashboardSearchButton: {
      label: "Cercar..."
    },
    dashboardSidebarCollapse: {
      collapse: "Contraure barra lateral",
      expand: "Expandir barra lateral"
    },
    dashboardSidebarToggle: {
      close: "Tancar barra lateral",
      open: "Obrir barra lateral"
    },
    error: {
      clear: "Tornar a l'inici"
    },
    fileUpload: {
      removeFile: "Eliminar {filename}"
    },
    header: {
      close: "Tancar men\xFA",
      open: "Obrir men\xFA"
    },
    inputMenu: {
      create: 'Crear "{label}"',
      noData: "Sense dades",
      noMatch: "No hi ha dades coincidents"
    },
    inputNumber: {
      decrement: "Decrementar",
      increment: "Incrementar"
    },
    modal: {
      close: "Tancar"
    },
    pricingTable: {
      caption: "Comparaci\xF3 de plans de preu"
    },
    prose: {
      codeCollapse: {
        closeText: "Replega",
        name: "codi",
        openText: "Desplega"
      },
      collapsible: {
        closeText: "Amaga",
        name: "propietats",
        openText: "Mostra"
      },
      pre: {
        copy: "Copiar codi al portapapers"
      }
    },
    selectMenu: {
      create: 'Crear "{label}"',
      noData: "Sense dades",
      noMatch: "No hi ha dades coincidents",
      search: "Cerca..."
    },
    slideover: {
      close: "Tancar"
    },
    table: {
      noData: "Sense dades"
    },
    toast: {
      close: "Tancar"
    }
  }
});
